import { FC, useState } from 'react';
import {
  Box,
  FormControl,
  FormErrorMessage,
  Textarea,
} from '@wegroup/design-system';
import { Control, Controller } from 'react-hook-form';
import { Language, LanguageNew } from '../../../../../../types/Common';
import { getModalLangTabs } from '@settings/src/features/risk-domains/utils/modal';
import LanguageTabs from '@common/src/components/LanguageTabs';

interface Props {
  name: string;
  control: Control;
  defaultValues: Record<string, string>;
  isDisabled?: boolean;
  lang?: string;
  isNL?: boolean;
}

const MultiLanguageTextInput: FC<Props> = ({
  control,
  defaultValues,
  name,
  isDisabled,
  lang: userLang = 'nl',
  isNL = false,
}) => {
  const [selectedLang, setSelectedLang] = useState<LanguageNew>(
    userLang as Language,
  );
  const valueObject = defaultValues;

  const getCompletedTabs = () => {
    if (!valueObject) return [];
    return Object.entries(valueObject).reduce((acc, [key, val]) => {
      if (val) {
        acc.push(key as LanguageNew);
      }
      return acc;
    }, [] as LanguageNew[]);
  };

  const customTabs = getModalLangTabs({
    nl: 'nl',
    fr: 'fr',
    en: 'en',
    de: 'de',
  }).filter(({ value }) => value !== 'de');

  return (
    <Box
      bg="white"
      border="1px"
      borderColor="gray.50"
      borderRadius="md"
      overflow="hidden"
    >
      {!isNL && (
        <LanguageTabs
          value={selectedLang}
          onChange={setSelectedLang}
          completedTabs={getCompletedTabs()}
          customTabs={customTabs}
          isFitted={false}
        />
      )}
      <Controller
        key={selectedLang}
        control={control}
        name={`${name}.${selectedLang}`}
        render={({
          field: { onChange, value, ref },
          fieldState: { error },
        }) => {
          return (
            <FormControl isInvalid={!!error}>
              <Textarea
                ref={ref}
                style={{
                  borderTopLeftRadius: '0',
                  borderTopRightRadius: '0',
                  border: 0,
                }}
                value={value || ''}
                onChange={onChange}
                isDisabled={isDisabled}
              />
              {error?.message && (
                <FormErrorMessage>{error.message}</FormErrorMessage>
              )}
            </FormControl>
          );
        }}
      />
    </Box>
  );
};

export default MultiLanguageTextInput;
